import { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { connect } from "react-redux";
import {
  checkIsValidForm,
  updateErrorsForm,
} from "../../services/manageValidation";
import Company from "../../components/Company/Company";
import HotSpot from "../../components/HotSpot/HotSpot";
import HotSpotForm from "../HotSpotForm/HotSpotForm";
import Button from "../../components/Button/Button";
import SpotForm from "../SpotForm/SpotForm";
import Pencil from "../../icons/pencil.svg";
import Icon from "../../components/Icon/Icon";
import { getSpotLink } from "../../services/linkGenerator";
import { updateSpotStor, updateSpotDatabase } from "../../reduxSetup/action.js";
import { getSpotByTypeKeyAPI, updateUserAPI } from "../../services/api";
import GreenSpotForm from "../GreenSpotForm/GreenSpotForm";
import styles from "./SpotContainer.module.scss";

const SpotContainer = ({
  company,
  onSave,
  type,
  language = "en",
  updateSpotStor,
  updateSpotDatabase,
  isResearcher,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [comment, setComment] = useState("");
  const [isCopySuccess, setIsCopySuccess] = useState("");

  const onUpdate = (data) => {
    const {
      name,
      countries,
      usState,
      website,
      address,
      email,
      organizationFields,
      businessFields,
      category,
      setValidationError,
      photos,
      videos,
      problem,
      solutions,
      timeline,
      faq,
      links,
      titleSeo,
      descriptionSeo,
      author,
      date,
      key,
      originalId,
      originalType,
      relatedOrganizations,
      status,
      _id,
      description,
      location,
      loc,
      logo,
      photo,
      hotSpotFields,
      greenSpotFields,
      userOwner,
      phone,
      employeesNumber,
      languages,
      socialMedia,
      foundationDate,
      source,
      addresses,
      city,
      line2,
      postcode,
    } = data;

    const state = {
      name,
      countries,
      usState,
      website,
      address,
      organizationFields,
      businessFields,
      category,
      type,
      email,
      photos: photos?.filter(Boolean),
      videos,
      problem,
      solutions,
      timeline,
      faq,
      links,
      titleSeo,
      descriptionSeo,
      hotSpotFields,
      greenSpotFields,
      userOwner,
    };

    if (!checkIsValidForm({ state })) {
      updateErrorsForm({
        state,
        setValidationError,
      });
      return;
    }
    const fields = () => {
      if (type === "NGO") {
        return organizationFields;
      }
      if (type === "business") {
        return businessFields;
      }

      if (type === "hotSpot") {
        return hotSpotFields;
      }
      if (type === "greenSpot") {
        return greenSpotFields;
      }

      if (
        type !== "NGO" &&
        type !== "business" &&
        !type === "hotSpot" &&
        !type === "greenSpot"
      )
        return null;
    };
    const companyToSave = {
      name,
      country: countries?.[0],
      state: countries?.[0] === "USA" ? usState?.[0] || "" : "",
      countries,
      link: website,
      address,
      email,
      fields: fields(),
      category,
      photos,
      problem,
      solutions,
      timeline,
      faq,
      links,
      author,
      date,
      key,
      originalId,
      originalType,
      relatedOrganizations,
      status,
      _id,
      description,
      location,
      loc,
      logo,
      photo,
      videos,
      titleSeo,
      descriptionSeo,
      userOwner,
      phone,
      employeesNumber,
      languages,
      socialMedia,
      foundationDate,
      source,
      addresses,
      city,
      line2,
      postcode,
      type,
    };
    if (type === "hotSpot" || type === "greenSpot") {
      companyToSave.date = new Date().toISOString();
    }
    updateSpotStor(companyToSave, type);
    updateSpotDatabase(companyToSave, type);
    setIsEdit(false);
  };

  const updateUser = (status) => {
    let changeField;
    let value;
    if (company.originalId) {
      changeField = "message";
      if (status === "rejected") {
        value =
          "Latest changes rejected. Details and recommendations in your companie's email";
      }
      if (status === "approved") {
        value = "Resent changes were approved";
      }
    }
    if (!company.originalId) {
      changeField = "status";
      value = status;
    }
    updateUserAPI({
      email: company?.userOwner,
      status: { companyKey: company?.key, value, changeField },
    });
  };

  const onSendToTheAuthor = (status) => {
    const data = { ...company };
    data.comment = comment;
    data.status = status;

    updateUser(status);
    updateSpotDatabase(data, type);
  };

  const shareSpot = (currentSpot) => {
    getSpotByTypeKeyAPI({
      spotKey: currentSpot?.key,
      type: currentSpot?.originalType || type,
    }).then((response) => {
      const typeToLink = currentSpot.originalType || type;
      const url = getSpotLink(typeToLink, currentSpot.name, currentSpot.key);
      navigator.clipboard.writeText(url);
      setIsCopySuccess(true);
      setTimeout(() => {
        setIsCopySuccess(false);
      }, 500);
    });
  };

  return (
    <div className={styles.companyContainer}>
      {!isEdit && (
        <>
          {type === "hotSpot" || type === "greenSpot" ? (
            <HotSpot spot={company} />
          ) : (
            <Company company={company} />
          )}
          <div className={styles.buttonsContainer}>
            {(type === "hotSpot" || type === "greenSpot"
              ? company.key
              : company.originalId) && (
              <Button
                className={cx(styles.getLinkButton, styles.button)}
                onClick={() => shareSpot(company)}
              >
                Get original URL
              </Button>
            )}
            {isCopySuccess && (
              <p className={styles.linkSuccess}>Link successfully copied</p>
            )}

            {!isResearcher && (
              <>
                <Button
                  disabled={company.status !== "onreview"}
                  className={cx(styles.saveButton, styles.button)}
                  onClick={() => {
                    updateUser("approved");
                    onSave(company, type);
                  }}
                >
                  Save
                </Button>
                <Button
                  disabled={company.status !== "onreview"}
                  onClick={() => setIsEdit(true)}
                  className={styles.editButton}
                >
                  <Icon name={Pencil} />
                </Button>
              </>
            )}
            {!isResearcher && company.status === "onreview" && (
              <div className="mt-5">
                <h5>Add a comment for the author</h5>
                <div className={styles.commentContainer}>
                  <div>
                    <textarea onChange={(e) => setComment(e.target.value)} />
                  </div>

                  <div className={styles.commentContainerButtons}>
                    {/* <Button
                      disabled={company.status !== "onreview"}
                      className={cx(styles.sendToTheAuthor, styles.button)}
                      onClick={() => onSendToTheAuthor("improve")}
                    >
                      Improve
                    </Button> */}
                    <Button
                      disabled={company.status !== "onreview"}
                      className={cx(styles.rejectButton, styles.button)}
                      onClick={() => onSendToTheAuthor("rejected")}
                    >
                      Reject
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {isEdit && (
        <div className={styles.editContainer}>
          {type === "hotSpot" ? (
            <HotSpotForm
              handleSubmit={onUpdate}
              type={type}
              spotToEdit={company}
            />
          ) : type === "greenSpot" ? (
            <GreenSpotForm
              handleSubmit={onUpdate}
              type={type}
              spotToEdit={company}
            />
          ) : (
            <SpotForm
              handleSubmit={onUpdate}
              type={type}
              spotToEdit={company}
              clearAll={() => {}}
            />
          )}
        </div>
      )}
    </div>
  );
};

SpotContainer.propTypes = {
  company: PropTypes.object,
  onSave: PropTypes.func,
  type: PropTypes.string,
  language: PropTypes.string,
  updateSpotStor: PropTypes.func,
  updateSpotDatabase: PropTypes.func,
  isResearcher: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const { language } = state;
  return {
    language,
  };
};

const mapDispatchToProps = {
  updateSpotStor,
  updateSpotDatabase,
};

export default connect(mapStateToProps, mapDispatchToProps)(SpotContainer);
